import cntl from "cntl";
import PropTypes from "prop-types";
import { SIZE, BUTTON_VARIANTS, POSITIONS } from "../constants/index";
import Button from "./Button";

const propTypes = {
  icon: PropTypes.object,
  name: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  iconColor: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  size: PropTypes.oneOf([SIZE.sm, SIZE.md, SIZE.lg, SIZE.xl, SIZE["2xl"]]),
  variant: PropTypes.oneOf([
    BUTTON_VARIANTS.default,
    BUTTON_VARIANTS.border,
    BUTTON_VARIANTS.light,
    BUTTON_VARIANTS.border_off,
  ]),
  iconPosition: PropTypes.oneOf([POSITIONS.left, POSITIONS.right]),
};

function ButtonError({
  icon,
  name,
  size,
  type,
  label,
  onClick,
  disabled,
  iconColor,
  className,
  isLoading,
  iconPosition,
  variant = BUTTON_VARIANTS.default,
}) {
  const defaultCn = () => cntl`
    text-white
    shadow-sm
    enabled:bg-error-600
    disabled:bg-error-100
    enabled:border-error-600
    disabled:border-error-100
    enabled:hover:bg-error-700 enabled:hover:border-error-700
    focus:bg-error-600 focus:border-error-600 focus:outline focus:outline-4 focus:outline-error-100
    ${className ? className : undefined}
  `;

  const lightCn = () => cntl`
    shadow-sm
    enabled:text-error-700
    disabled:text-error-300
    enabled:bg-error-50
    disabled:bg-error-25
    enabled:border-error-50
    disabled:border-error-25
    enabled:hover:bg-error-100 enabled:hover:border-error-100
    focus:bg-error-50 focus:border-error-50 focus:outline focus:outline-4 focus:outline-error-100
    ${className ? className : undefined}
  `;

  const borderCn = () => cntl`
    bg-white
    shadow-sm
    enabled:text-error-700
    disabled:text-error-300
    enabled:border-error-300
    disabled:border-error-200
    enabled:hover:bg-error-50 enabled:hover:border-error-300 enabled:hover:text-error-800
    focus:bg-white focus:border-error-300 focus:outline focus:outline-4 focus:outline-error-100
    ${className ? className : undefined}
  `;

  const borderOffCn = () => cntl`
    bg-transparent
    border-transparent
    enabled:text-error-700
    disabled:text-error-300
    enabled:hover:bg-error-50 enabled:hover:border-error-50 enabled:hover:text-error-700
    focus:bg-transparent focus:border-transparent
    ${className ? className : undefined}
  `;

  return (
    <>
      {variant === BUTTON_VARIANTS.default && (
        <Button
          name={name}
          type={type}
          size={size}
          icon={icon}
          label={label}
          onClick={onClick}
          disabled={disabled}
          iconColor={iconColor}
          isLoading={isLoading}
          className={defaultCn()}
          iconPosition={iconPosition}
        />
      )}
      {variant === BUTTON_VARIANTS.light && (
        <Button
          name={name}
          type={type}
          size={size}
          icon={icon}
          label={label}
          onClick={onClick}
          disabled={disabled}
          iconColor={iconColor}
          isLoading={isLoading}
          className={lightCn()}
          iconPosition={iconPosition}
        />
      )}
      {variant === BUTTON_VARIANTS.border && (
        <Button
          name={name}
          type={type}
          size={size}
          icon={icon}
          label={label}
          onClick={onClick}
          disabled={disabled}
          iconColor={iconColor}
          isLoading={isLoading}
          className={borderCn()}
          iconPosition={iconPosition}
        />
      )}
      {variant === BUTTON_VARIANTS.border_off && (
        <Button
          name={name}
          type={type}
          size={size}
          icon={icon}
          label={label}
          onClick={onClick}
          disabled={disabled}
          iconColor={iconColor}
          isLoading={isLoading}
          className={borderOffCn()}
          iconPosition={iconPosition}
        />
      )}
    </>
  );
}

ButtonError.propTypes = propTypes;
export default ButtonError;
